import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "../../components/header/Header"; // Adjust the import path

import "./App.css";

import Login from "../../components/Login/Login";
import Register from "../../components/Login/Register";
import Password from "../../components/Login/Password";
import Newpassword from "../../components/Login/Newpassword";
import CustomerSection from "../../components/CustomerSection/CustomerSection";
import StaffSection from "../../components/StaffSection/StaffSection";
import Addstaff from "../../components/Staff/AddStaff";
import { Edit_Staff } from "../../components/Staff/Edit_Staff";
import SettingsSection from "../../components/SettingsSection/SettingsSection";
import AddCustomer from "../../components/Customer/Add_Customer";
import EditCustomer from "../../components/Customer/Edit_Customer";
import Ottdetails from "../../components/Settings/Ottdetails";
import Leadsource from "../../components/Settings/Leadsource";
import LocationSection from "../../components/LocationSection/LocationSection";
import AdministrationSection from "../../components/AdministrationSection/AdministrationSection";
import RolesList from "../../components/Adminstration/RolesList";
import Dashboard from "../../components/Dashboard/Dashboard";

import Recovery from "../../components/Recovery/Recovery";
import AddRecovery from "../../components/Recovery/AddRecovery";
import View_Enquiry from "../../components/Enquiry/View_Enquiry";
import EditTask from "../../components/Task/EditTask"

import Task from "../../components/Task/Task";
import CreateTask from "../../components/Task/CreateTask";
import MyTask from "../../components/Task/MyTask";
import MapView from "../../components/Task/MapView";
import TaskListView from "../../components/Task/TaskListView";
import NewTask from "../../components/Task/NewTask";
import TaskCard from "../../components/Task/TaskCard";
import TaskCard1 from "../../components/Task/TaskCard1";
import ViewTask from "../../components/Task/ViewTask";
import TaskProcess from "../../components/Task/TaskProcess";
import AddEnquiry from "../../components/Enquiry/AddEnquiry";
import Add_Complaint from "../../components/Complaint/Add_Complaint";
import Enquiry from "../../components/Enquiry/Enquiry";
import Installation from "../../components/Installation/Installation";
// import Recovery from "../../components/Recovery/Recovery";
import Complaint from "../../components/Complaint/Complaint";

// import Dues from "../../components/Dues/Dues";

import View_Installation from "../../components/Installation/View_Installation";
import View_Recurring from "../../components/Task/View_Recurring";

import View_CreateTask from "../../components/Task/View_CreateTask";

// import Stock from "../../components/Stock/Stock";
import AttendanceSection from "../../components/AttendanceSection/AttendanceSection";

import Stock from "../../components/Stock/Stock";
import View_Complaint from "../../components/Complaint/View_Complaint";
import Feedback_Complaint from "../../components/Complaint/Feedback_Complaint";

import FiberTeam_Complaint from "../../components/Complaint/FiberTeam_Complaint";
import NetworkTeam_Complaint from "../../components/Complaint/NetworkTeam_Complaint";
import OrderDetails_Complaint from "../../components/Complaint/OrderDetails_Complaint";
import Payment_Complaint from "../../components/Complaint/Payment_Complaint";
import Verification_Complaint from "../../components/Complaint/Verification_Complaint";
import WorkAssign_Complaint from "../../components/Complaint/WorkAssign_Complaint";

// import Menu from "../../components/Menu/Menu";

import Roles from "../../components/Roles/Roles";

import Logout from "../../components/Login/Logout";
import NoPage from "../../components/NoPage";

import Add_Installation from "../../components/Installation/Add_Installation";
// import Add_Enquiry from "../../components/Enquiry/Add_Enquiry";
// import Edit_Installation from "../../components/Installation/Edit_Installation";
import CustomerReportSection from "../../components/CustomerReportSection/CustomerReportSection";
import StaffAnalysisSection from "../../components/StaffAnalysisSection/StaffAnalysisSection";
// import LocationSection from "../../components/LocationSection/LocationSection";

import View_Customer from "../../components/Customer/View_Customer";
import { AddStock } from "../../components/Stock/AddStock";
import { PlusStock } from "../../components/Stock/PlusStock";
// import { AddSctock, AddStock } from "../../components/Stock/AddStock";
import ManageStock from "../../components/Stock/ManageStock";

import ViewRecovery from "../../components/Recovery/ViewRecovery";
import DuesSection from "../../components/DuesSection/DuesSection";
import AddDues from "../../components/Dues/AddDues";
import ViewDues from "../../components/Dues/ViewDues";

import Recurring from "../../components/Task/Recurring";
import Add_Recurring from "../../components/Task/Add_Recurring";

import Notification from "../../components/Notification/Notification";
import { Routermodelselling } from "../../components/Settings/Routermodelselling";
import { Fibermeterselling } from "../../components/Settings/Fibermeterselling";


const MainLayout = () => {
  const location = useLocation();

  // Routes that should not display the Header
  const noHeaderRoutes = ["/", "/password", "/newpassword", "/register", "/*"];
  const is404Page = ![
    "/",
    "/logout",
    "/register",
    "/password",
    "/newpassword",
    "/customersection",
    "/add_customer",
    "/edit_customer",
    "/staffsection",
    "/addstaff",
    "/roles",
    "/editStaff",
    "/administrationsection",
    "/role",
    "/settingssection",
    "/routermodelselling",
    "/fibermeterselling",
    "/ottdetails",
    "/leadsource",
    "/page1",
    "/page2",
    "/edit_installation",
    "/add_installation",
    "/dashboard",
    "/task",
    "/createtask",
    "/tasklistview",
    "/mytask",
    "/newtask",
    "/taskcard",
    "/taskcard1",
    "/viewtask",
    "/taskprocess",
    "/denyupopup",
    "/enquiry",
    "/installation",
    "/add_installation",
    "/edit_installation",

    "/complaint",
    "/duessection",
    "/adddues",
    "/view_dues",

    "/addstock",
    "/plusstock",
    "/stock",
    "/managestock",
    "/menu",
    "/view_enquiry",
    "/attendancesection",
    "/locationsection",
    "/customerreportsection",
    "/staffanalysissection",
    "/view_customer",
    "/addenquiry",
    "/add_complaint",

    "/view_complaint",

    "/recovery",
    "/addrecovery",
    "/viewrecovery",
    "/view_installation",
    "/view_createtask",
    "/recurring",
    "/addrecurring",
    "/viewrecurring",
    "/notification",
    "/taskmapview",
    "/edittask"
  ].includes(location.pathname);

  return (
    <div className="app-container">
      {/* Conditionally render Header based on current pathname */}

      {!noHeaderRoutes.includes(location.pathname) && !is404Page && <Header />}

      <div className="content-container">
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path="/login" element={<Login />} /> */}

          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Register />} />
          <Route path="/password" element={<Password />} />
          <Route path="/newpassword" element={<Newpassword />} />

          {/*----- //Dashboard Module -----*/}
          <Route path="/dashboard" element={<Dashboard />} />
          {/*----- //task Module -----*/}
          <Route path="/task" element={<Task />} />
          <Route path="/createtask" element={<CreateTask />} />
          <Route path="/mytask" element={<MyTask />} />
          <Route path="/taskmapview" element={<MapView />} />
          <Route path="/tasklistview" element={<TaskListView />} />
          <Route path="/newtask" element={<NewTask />} />
          <Route path="/taskcard" element={<TaskCard />} />
          <Route path="/taskcard1" element={<TaskCard1 />} />
          <Route path="/viewtask" element={<ViewTask />} />
          <Route path="/taskprocess" element={<TaskProcess />} />
          <Route path="/view_createtask" element={<View_CreateTask />} />
          <Route path="/recurring" element={<Recurring />} />
          <Route path="/addrecurring" element={<Add_Recurring />} />
          <Route path="/viewrecurring" element={<View_Recurring />} />
          <Route path="/edittask" element={<EditTask />} />

          {/*----- //Enquiry Module -----*/}
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/addenquiry" element={<AddEnquiry />} />
          <Route path="/view_enquiry" element={<View_Enquiry />} />
          {/*----- //Installation Module -----*/}
          <Route path="/installation" element={<Installation />} />
          <Route path="/add_installation" element={<Add_Installation />} />
          <Route path="/view_installation" element={<View_Installation />} />
          {/*----- //Complaint Module -----*/}
          <Route path="/complaint" element={<Complaint />} />
          <Route path="/add_complaint" element={<Add_Complaint />} />
          <Route path="/view_complaint" element={<View_Complaint />} />
          {/*----- //Dues Module -----*/}
          <Route path="/duessection" element={<DuesSection />} />
          <Route path="/adddues" element={<AddDues />} />
          <Route path="/view_dues" element={<ViewDues />} />

          {/*----- //Stocks Module -----*/}
          <Route path="/stock" element={<Stock />} />
          <Route path="/addstock" element={<AddStock />} />
          <Route path="/plusstock" element={<PlusStock />} />
          {/*----- //Stock sub Module -----*/}
          <Route path="/managestock" element={<ManageStock />} />
          {/*----- //Recovery Module -----*/}
          <Route path="/recovery" element={<Recovery />} />
          <Route path="/addrecovery" element={<AddRecovery />} />
          <Route path="/viewrecovery" element={<ViewRecovery />} />
          {/*----- //CustomerReport Module -----*/}
          <Route
            path="/customerreportsection"
            element={<CustomerReportSection />}
          />
          {/*----- //Staff Analysis Report Module -----*/}
          <Route
            path="/staffanalysissection"
            element={<StaffAnalysisSection />}
          />

          {/*----- //Attendance Module -----*/}
          <Route path="/attendancesection" element={<AttendanceSection />} />

          {/*----- //Location Module -----*/}

          <Route path="/locationsection" element={<LocationSection />} />
          {/*----- //Staff Module -----*/}
          <Route path="/staffsection" element={<StaffSection />} />
          <Route path="/addstaff" element={<Addstaff />} />
          <Route path="/editStaff" element={<Edit_Staff />} />
          {/*----- //Customer Module -----*/}
          <Route path="/customersection" element={<CustomerSection />} />
          <Route path="/add_customer" element={<AddCustomer />} />
          <Route path="/view_customer" element={<View_Customer />} />
          <Route path="/edit_customer" element={<EditCustomer />} />
          {/*----- //Setting Module -----*/}
          <Route path="/settingssection" element={<SettingsSection />} />
          <Route path="/ottdetails" element={<Ottdetails />} />
          <Route path="/leadsource" element={<Leadsource />} />
          <Route path="/routermodelselling" element={<Routermodelselling />} />
          <Route path="/fibermeterselling" element={<Fibermeterselling />} />

          {/*----- //Administrative Module -----*/}
          <Route
            path="/administrationsection"
            element={<AdministrationSection />}
          />
          <Route path="/role" element={<RolesList />} />
          {/*----- //Administrative sub Module -----*/}
          <Route path="/roles" element={<Roles />} />

          <Route path="*" element={<NoPage />} />
          <Route path="/notification" element={<Notification />} />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <MainLayout />
    </Router>
  );
};

export default App;
